import React from 'react'
import { Dimensions} from 'react-native'
import { scaleSize } from '../../../../Utils/responsive';
import NoSinsToken from "../../../../assets/svg/Token-NoSins.svg";
import PeoplePlanetToken from "../../../../assets/svg/Token-PeoplePlanet.svg";
import PlanetToken from "../../../../assets/svg/Token-Planet.svg";
import PlanetOverReturnsToken from "../../../../assets/svg/Token-PlanetOverReturns.svg";
import ReturnsOverPlanetToken from "../../../../assets/svg/Token-ReturnsOverPlanet.svg";
import PeopleOverReturnsToken from "../../../../assets/svg/Token-PeopleOverReturns.svg";
import ReturnsOverPeopleToken from "../../../../assets/svg/Token-ReturnsOverPeople.svg";
import BothOverReturnsToken from "../../../../assets/svg/Token-BothOverReturns.svg";
import ReturnsOverBothToken from "../../../../assets/svg/Token-ReturnsOverBoth.svg";
import PositiveImpactToken from "../../../../assets/svg/Token-PositiveImpact.svg";
import PeopleToken from "../../../../assets/svg/Token-People.svg";
import CarbonNeutralToken from "../../../../assets/svg/Token-CarbonNeutral.svg";
import AllToken from "../../../../assets/svg/Token-All.svg";
const actualWidth = Dimensions.get("screen").width;
const DragGames = (props) => {
  return (
    <>
      {props.iconKey === "planet" && (
        <img
          alt=""
          src={PlanetToken}
          style={{
            width: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            height: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "people" && (
        <img
          alt=""
          src={PeopleToken}
          style={{
            width: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            height: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "planetandpeople" && (
        <img
          alt=""
          src={PeoplePlanetToken}
          style={{
            width: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            height: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "planetmoney" && (
        <img
          alt=""
          src={PlanetOverReturnsToken}
          style={{
            width: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            height: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "moneyplanet" && (
        <img
          alt=""
          src={ReturnsOverPlanetToken}
          style={{
            width: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            height: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "positiveonly" && (
        <img
          alt=""
          src={PositiveImpactToken}
          style={{
            width: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            height: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "carbonneutral" && (
        <img
          alt=""
          src={CarbonNeutralToken}
          style={{
            width: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            height: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "screen" && (
        <img
          alt=""
          src={NoSinsToken}
          style={{
            width: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            height: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "all" && (
        <img
          alt=""
          src={AllToken}
          style={{
            width: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            height: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "peoplemoney" && (
        <img
          alt=""
          src={PeopleOverReturnsToken}
          style={{
            width: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            height: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "moneypeople" && (
        <img
          alt=""
          src={ReturnsOverPeopleToken}
          style={{
            width: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            height: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "bothmoney" && (
        <img
          alt=""
          src={BothOverReturnsToken}
          style={{
            width: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            height: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            objectFit: "contain",
          }}
        />
      )}
      {props.iconKey === "moneyboth" && (
        <img
          alt=""
          src={ReturnsOverBothToken}
          style={{
            width: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            height: scaleSize(actualWidth > 600 ? 114 : actualWidth > 400 ? 124 : 62),
            objectFit: "contain",
          }}
        />
      )}
    </>
  );
};
export default DragGames;